// import React from "react";
// // import "./footer.css";
// import Grid from "@mui/material/Grid";
// import Paper from "@mui/material/Paper";
// import { styled } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import PopularCarSection from "./popularCarSection";
// import AffordableCarSection from "./affordableCarSection";
// import BusinessPartners from "./businessPartners";
// import FooterManual from "./footerManual";
// import TestimonialCarousel from "./testimonialCarousel";
 
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
//   ...theme.applyStyles("dark", {
//     backgroundColor: "#1A2027",
//   }),
// }));
 
// export default function Footer() {
//   return (
//     <div>
//       {/* our most trusted section start  */}
//       <div className="container-fluid">
//         <div className="main">
//           <span>Our Most</span>
//           <p>Trusted Values</p>
//           <typography className="three-lines">
//             We prioritize reliability, transparency, and customer satisfaction to ensure a seamless car-buying experience.
//           </typography>
//         </div>
//         <Grid className="container-main" container spacing={3}>
//           {/* Each grid item spans 2.4 columns (12 ÷ 5 = ~2.4) */}
//           <Grid item xs={12} sm={6} md={2.4} className="grid-parent">
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/watch.svg"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" }, // Different widths for xs, sm, and md breakpoints
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="ready-to-ship">
//                 Ready to Ship in 24 Hours
//               </p>
//               <p>Swift processing to dispatch your order without delays.</p>
//             </Item>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2.4} className="grid-parent">
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/Delivery.svg"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" }, // Different widths for xs, sm, and md breakpoints
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="first-class-air">
//                 First-Class Air Courier
//               </p>
//               <p>Get your car delivered to your doorstep within 3 days, worldwide.</p>
//             </Item>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2.4} className="grid-parent">
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/purchase.svg"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" }, // Different widths for xs, sm, and md breakpoints
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="optimal-purchase">
//                 No Hidden Charges
//               </p>
//               <p>Transparent pricing with no unexpected costs.</p>
//             </Item>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2.4} className="grid-parent">
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/tracking.svg"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" }, // Different widths for xs, sm, and md breakpoints
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="online-order">Online Order Tracking</p>
//               <p>Stay updated with real-time tracking of your shipment.</p>
//             </Item>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2.4} className="grid-parent" sx={{paddingRight:"10px"}}>
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/color.png"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" }, // Different widths for xs, sm, and md breakpoints
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="color-match">Quality & Service Guarantee</p>
//               <p>We ensure top-notch quality and exceptional customer service for a worry-free purchase.</p>
//             </Item>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             sm={6}
//             md={2.4}
//             className="grid-parent"
//             sx={{
//               display: { md: "none", lg: "none" }, // Hide on md and larger screens
//             }}
//           >
//             <Item className="item">
//               <Box
//                 component="img"
//                 src="/image/color.png"
//                 alt="Amar Icon"
//                 sx={{
//                   width: { xs: "50px", sm: "50px", md: "50px" },
//                   height: "auto",
//                   marginLeft: "10px",
//                 }}
//               />
//               <p className="color-match">Color Match Guarantee</p>
//             </Item>
//           </Grid>
//         </Grid>
//       </div>
//       {/* our most trusted section end  */}
//       <FooterManual />
//       {/* </div> */}
//     </div>
//   )
// }


import React from "react";
import "./footer.css";
import { Box, Grid, Typography } from "@mui/material";
import FooterManual from "./footerManual";

const values = [
  {
    icon: "/image/watch.svg",
    title: "Ready to Ship in 24 Hours",
    desc: "Swift processing to dispatch your order without delays.",
  },
  {
    icon: "/image/Delivery.svg",
    title: "First-Class Air Courier",
    desc: "Get your car delivered to your doorstep within 3 days, worldwide.",
  },
  {
    icon: "/image/purchase.svg",
    title: "No Hidden Charges",
    desc: "Transparent pricing with no unexpected costs.",
  },
  {
    icon: "/image/tracking.svg",
    title: "Online Order Tracking",
    desc: "Stay updated with real-time tracking of your shipment.",
  },
  {
    icon: "/image/color.png",
    title: "Quality & Service Guarantee",
    desc: "We ensure top-notch quality and exceptional customer service for a worry-free purchase.",
  },
];

export default function Footer() {
  return (
    <Box>
      <Box
      className="container-fluid"
      sx={{
      width: "100%",
      py: 5,
      backgroundColor: "#FDFDFD",
      textAlign: "center"
    }}
      >
        {/* <Typography variant="h5" className="trusted-heading">
          Our Most <span className="trusted-red">Trusted Values</span>
        </Typography>
        <Typography sx={{textAlign:"center", justifyContent:"center"}} className="trusted-subheading">
          We prioritize reliability, transparency, and customer satisfaction to ensure a seamless car-buying experience.
        </Typography> */}
        <Typography
                  variant="h3"
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "28px", sm: "32px", md: "40px" },
                    mb: 2,
                    mt: 5
                  }}
                >
                  <span style={{ color: "#eb2329" }}>Our Most</span>
                  <span style={{ color: "#000000", marginLeft: "10px" }}>Trusted Values</span>
                </Typography>
                {/* Red underline */}
                <Box
                  sx={{
                    width: "60px", // adjust width as per taste
                    height: "3px",
                    backgroundColor: "#eb2329",
                    borderRadius: "2px",
                    mx: "auto",
                    mb: 2
                  }}
                />

                <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "12px", sm: "14px" },
                            maxWidth: "600px",
                            mx: "auto"
                          }}
                        >
                          We prioritize reliability, transparency, and customer satisfaction to ensure a seamless car-buying experience.
                        </Typography>
      </Box>

      <Grid container spacing={5} className="trusted-grid">
        {values.map((item, index) => (
          <Grid item xs={12} sm={6} md={2.4} key={index} className="trusted-grid-item">
            <img src={item.icon} alt="icon" className="trusted-icon" />
            <Typography className="trusted-title">{item.title}</Typography>
            <Typography className="trusted-desc">{item.desc}</Typography>
          </Grid>
        ))}
      </Grid>
      <FooterManual />
    </Box>
  );
}